const regions = [
  { label: 'город Ташкент', value: 'город Ташкент' },
  { label: 'Ташкентская область', value: 'Ташкентская область' },
  { label: 'Андижанская область', value: 'Андижанская область' },
  { label: 'Бухарская область', value: 'Бухарская область' },
  { label: 'Джизакская область', value: 'Джизакская область' },
  { label: 'Кашкадарьинская область', value: 'Кашкадарьинская область' },
  { label: 'Навоийская область', value: 'Навоийская область' },
  { label: 'Наманганская область', value: 'Наманганская область' },
  { label: 'Республика Каракалпакстан', value: 'Республика Каракалпакстан' },
  { label: 'Самаркандская область', value: 'Самаркандская область' },
  { label: 'Сурхандарьинская область', value: 'Сурхандарьинская область' },
  { label: 'Сырдарьинская область', value: 'Сырдарьинская область' },
  { label: 'Ферганская область', value: 'Ферганская область' },
  { label: 'Хорезмская область', value: 'Хорезмская область' },
];

export default regions;